// @flow
import { appApi } from '../config/api.config';
import { API_PATHS, BASE_URL } from '../config/api.constants';

export const getEmails = (params) => appApi.post(BASE_URL + API_PATHS.ADMIN + API_PATHS.EMAILS, params);
export const getLogs = (params) => appApi.post(BASE_URL + API_PATHS.ADMIN + API_PATHS.LOGS, params);
